import Page from "webPage/Page";

Page.register("single-software", () => {
    $('body').on('click', '.js-software-enquire', function () {
        try {
            dataLayer.push({'event': 'software-enquiry-click'});

            let target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(target).offset().top - 50
            }, 500);
        } catch (e) {
            console.log(e);
        }
    });

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        if (formId === 3 /* Software enquiry */) {
            try {
                dataLayer.push({'event': 'software-enquiry-submit'});
                gtag('event', 'submit_lead', {
                    'event_category': 'software', 'event_label': 'enquiry_form', 'value': '0'
                });
            } catch (e) {
                console.log(e);
            }
        }
    });
});

